import axios from "axios";

export const getAdjacentTechnologies = async (technology) => {
  const response = await axios.post(
    "/.netlify/functions/getAdjacentTechnologies",
    {
      technology,
    }
  );
  return response.data;
};

export const applyFrameworkToTechnology = async (technologyA, technologyB) => {
  const response = await axios.post(
    "/.netlify/functions/applyFrameworkToTechnology",
    {
      technologyA,
      technologyB,
    }
  );
  return response.data;
};
